function PlayCircle({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width="${dimensions || 54}" height="${dimensions || 54}" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M27.0002 0.333328C12.2802 0.333328 0.333496 12.28 0.333496 27C0.333496 41.72 12.2802 53.6667 27.0002 53.6667C41.7202 53.6667 53.6668 41.72 53.6668 27C53.6668 12.28 41.7202 0.333328 27.0002 0.333328ZM20.3335 39V15L39.0002 27L20.3335 39Z" fill="${col}"/>
    </svg>
  `;

  return baseXml;
}

export default PlayCircle;
